import React, {PropTypes} from 'react';
import moment from 'moment';

const SearchResultItem = ({
  entryId,
  entryNumber,
  tournamentName,
  teamName,
  captainId,
  captainName,
  eventType,
  bowlDateTime,
  coordinatorName,
  isCancelled,
  onEntryClick,
  onCaptainClick
}) => (
  <div className="list-group-item-labeled">
    <div className="list-group-item-labeled-child has-link"
      style={{width: 90}}
      onClick={() => onEntryClick(entryId)}>
      <span>{'Reservation No.'}</span>
      <span>{entryNumber || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 200}}>
      <span>{'Tournament'}</span>
      <span>{tournamentName || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <span>{'Team Name'}</span>
      <span>{teamName || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child has-link"
      style={{width: 150}}
      onClick={() => onCaptainClick(captainId)}>
      <span>{'Captain'}</span>
      <span>{`${captainName}`}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 150}}>
      <span>{'Coordinator'}</span>
      <span>{coordinatorName || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 75}}>
      <span>{'Event'}</span>
      <span>{eventType || '-'}</span>
    </div>
    <div className="list-group-item-labeled-child"
      style={{width: 200}}>
      <span>{'Bowl Date Time'}</span>
      <span>
        {
          bowlDateTime
          ? `${moment.parseZone(bowlDateTime).format('hh:mm A, MMM Do, YYYY')}`
          : isCancelled ? 'CANCELLED' : '-'
        }
      </span>
    </div>
  </div>
);

SearchResultItem.propTypes = {
  entryId: PropTypes.string,
  entryNumber: PropTypes.string,
  tournamentName: PropTypes.string,
  teamName: PropTypes.string,
  captainId: PropTypes.string,
  captainName: PropTypes.string,
  eventType: PropTypes.string,
  bowlDateTime: PropTypes.string,
  coordinatorName: PropTypes.string,
  isCancelled: PropTypes.bool,
  onEntryClick: PropTypes.func,
  onCaptainClick: PropTypes.func
};

SearchResultItem.defaultProps = {
  entryId: '',
  entryNumber: '',
  tournamentName: '',
  teamName: '',
  captainName: '',
  eventType: '',
  bowlDateTime: '',
  coordinatorName: '',
  isCancelled: false
};

export default SearchResultItem;



// WEBPACK FOOTER //
// ./src/features/admin/home/SearchResultItem.jsx